let idUser = "2587905";
let idInvoice = Math.floor(Math.random() * 9000000 + 1000000).toString();

// Mock Data para testes de usuário
export const mockUserData = {
  isLogged: true,
  cryptId: "7r/pTtBAfg==",
  user_identifier: idUser,
  name: "Philipinho Gomes",
  email: "philipinho93@gmail.com",
  lang: "us",
  parent: {
    aid: "10",
    name: "Internet Marketing LLC",
    avatar: "https://secure.gravatar.com/avatar/575ac3a5a09e51cb69f65a6c07eccd78?s=100&d=mm&r=g",
    is_concessionaire: false,
    receivement_gateways: null
  },
  avatar: "https://secure.gravatar.com/avatar/0e9a484dab9d7485950d89ff5f2182ae?s=100&d=mm&r=g",
  is_team_account: false,
  is_payment_only_paypal: false,
  pag_validade: "2026-02-02",
  is_virtual_assistant: false,
  va_name: null,
  va_tools_full_access: null,
  va_tools_resources: null,
  currency_code: "USD",
  current_plan: {
    id: "2765",
    title: "Premium Plan",
    slug: "free-usd",
    theme_type: "FREE"
  },
  vat_number: "EL078909371",
  first_payment: null,
  credit_cards: []
};

// Mock - usuário não logado
export const mockUserNotLogged = {
  isLogged: false,
  cryptId: null,
  user_identifier: null,
  name: null,
  email: null,
  lang: "us",
  parent: null,
  avatar: null,
  is_team_account: false,
  is_payment_only_paypal: false,
  pag_validade: null,
  is_virtual_assistant: false,
  va_name: null,
  va_tools_full_access: null,
  va_tools_resources: null,
  currency_code: "USD",
  current_plan: null,
  vat_number: null,
  first_payment: null,
  credit_cards: []
};

// Mock - Invoice Data
export const mockInvoiceData = {
  invoice: {
    id: idInvoice,
    user: {
      id: idUser
    },
    created_at: "2025-11-04 18:57:39"
  }
};

export default mockUserData;
